import React from "react";
import { Form, FormGroup } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { ReduxState } from "../../../../../redux";
import { setTemplateVisibility } from "../../../../../redux/reducers/TemplateMetadataFields";

type Props = {};
export const TemplateVisibility: React.SFC<Props> = ({}) => {
  const { visibility } = useSelector(
    (state: ReduxState) => state.TemplateMetadataFields
  );
  const dispatch = useDispatch();
  return (
    <FormGroup>
      <Form.Label>
        <strong>Visibility</strong>
      </Form.Label>
      <Select
        options={["private", "public"].map((x) => ({ value: x, label: x }))}
        value={{ label: visibility, value: visibility }}
        onChange={(value) => {
          dispatch(
            setTemplateVisibility(
              value ? (value.value as "private" | "public") : "private"
            )
          );
        }}
      />
    </FormGroup>
  );
};
export default TemplateVisibility;
